"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gridFragments = exports.allFragments = void 0;
const image_1 = require("./image");
const item_1 = require("./item");
const product_1 = require("./product");
const image_content_1 = require("./image-content");
const single_line_content_1 = require("./single-line-content");
const rich_text_content_1 = require("./rich-text-content");
const item_relations_content_1 = require("./item-relations-content");
const location_content_1 = require("./location-content");
const paragraph_collection_content_1 = require("./paragraph-collection-content");
const grid_1 = require("./grid");
const document_1 = require("./document");
const folder_1 = require("./folder");
const properties_table_content_1 = require("./properties-table-content");
const boolean_content_1 = require("./boolean-content");
__exportStar(require("./document"), exports);
__exportStar(require("./folder"), exports);
__exportStar(require("./grid"), exports);
__exportStar(require("./image"), exports);
__exportStar(require("./image-content"), exports);
__exportStar(require("./item"), exports);
__exportStar(require("./item-relations-content"), exports);
__exportStar(require("./location-content"), exports);
__exportStar(require("./paragraph-collection-content"), exports);
__exportStar(require("./product"), exports);
__exportStar(require("./rich-text-content"), exports);
__exportStar(require("./single-line-content"), exports);
__exportStar(require("./properties-table-content"), exports);
__exportStar(require("./boolean-content"), exports);
exports.allFragments = `
 ${item_1.itemFullFragment}
 ${product_1.productFragment}
 ${image_1.imageFragment}
 ${image_content_1.imageContentFragment}
 ${single_line_content_1.singleLineContentFragment}
 ${rich_text_content_1.richTextContentFragment}
 ${item_relations_content_1.itemRelationsContentFragment}
 ${location_content_1.locationContentFragment}
 ${paragraph_collection_content_1.paragraphCollectionContentFragment}
 ${properties_table_content_1.propertiesTableContentFragment}
 ${boolean_content_1.booleanContentFragment}
`;
exports.gridFragments = `
  ${grid_1.gridFragment}
  ${document_1.pimDocumentFragment}
  ${folder_1.folderFragment}
  ${product_1.productPreviewFragment}
`;
//# sourceMappingURL=index.js.map